import http from './http'
console.dir(http)
const api = {
    //——————首页——————
    banner: (data) => {
        //轮播
        return http.get('/api/home/banner', { params: data })
    },
    homeVideo: (data) => {
        //视频
        return http.get('/api/home/homeVideo', { params: data })
    },
    noticeList: (data) => {
        //公告列表
        return http.get('/api/home/noticeList', { params: data })
    },
    characterList: (data) => {
        //人物列表
        return http.get('/api/home/characterList', { params: data })
    },
    //-----详情-----
    characterInfo: (data) => {
        return http.get('/api/detail/characterInfo', { params: data })
    },
    noticeInfo: (data) => {
        return http.get('/api/detail/noticeInfo', { params: data })
    },
    newsInfo: (data) => {
        return http.get('/api/detail/newsInfo', { params: data })
    },
    activityInfo: (data) => {
        return http.get('/api/detail/activityInfo', { params: data })
    },
    awardInfo: (data) => {
        return http.get('/api/detail/awardInfo', { params: data })
    },
    characterDonorName: (data) => {
        return http.get('/api/home/characterDonorNames', { params: data })
    },
    // ------资讯--------
    newsList: (data) => {
        //最新资讯
        return http.get('/api/news/page/list', { params: data })
    },
    noticeList: (data) => {
        return http.get('/api/news/notice/page/list', { params: data })
    },
    newsSearch: (data) => {
        //搜索+资讯
        return http.get('/api/news/search', { params: data })
    },
    newsCategory: (data) => {
        return http.get('/api/news/newsCategory/list', { params: data })
    },
    newsYear: (data) => {
        return http.get('/api/news/newsCategory/year', { params: data })
    },
    //详情页  相关视频
    // relatedVideo: (data) => {
    //     return http.get('/api/activity/relevant', { params: data })
    // },
    //人物详情页 相关视频
    detailRelatedVideo: (data) => {
        return http.get('/api/relatedVideo/page/list', { params: data })
    },
    //公告 相关视频
    noticeRelatedVideo: (data) => {
        return http.get('/api/home/relevant', { params: data })
    },
    //人物详情页-视频-详情
    videoDetail: (data) => {
        return http.get('/api/relatedVideo/info', { params: data })
    },
    // ------活动------
    activityFirList: (data) => {
        return http.get('/api/activity/getFirList', { params: data })
    },
    activitySecList: (data) => {
        return http.get('/api/activity/getSecList', { params: data })
    },
    activitySearch: (data) => {
        return http.get('/api/activity/search', { params: data })
    },
    activityYear: (data) => {
        return http.get('/api/activity/years', { params: data })
    },

    // -------奖项与提名------
    characterYears: (data) => {
        return http.get('/api/home/characterYears', { params: data })
    },

    awardsList: (data) => {
        return http.get('/api/awards/list', { params: data })
    },
    // ------关于大奖------
    aboutList: (data) => {
        return http.get('/api/about/list', { params: data })
    },
    aboutContact: (data) => {
        return http.get('/api/about/contact', { params: data })
    },
    activityDetail: (data) => {
        return http.get('/api/detail/activityInfo', { params: data })
    },
    //未来大奖周
    getAgendaList: (data) =>{
        return http.get('/api/agenda/content/list', { params: data })
    },
    getLogo(data) {
        return http.get('/api/basicProject/getBasic', { params: data })
    },
    getBigAwardYearId: (data) => {
        return http.get('/api/project/list', { params: data })
    },
    getAgendList: (data) => {
        return http.get('/api/agenda/page/list', { params: data })
    },
    getPartnerList: (data) => {
        return http.get('/api/partners/page/list', { params: data })
    },
    getPrizeLookBack: (data) => {
        return http.get('/api/prizeLookBack/list', { params: data })
    },
    getPrizeContact: (data) => {
        return http.get('/api/prizeContact/get', { params: data })
    },
    getPrizeMeetings: (data) => {
        return http.get('/api/prizeMeetings/get', { params: data })
    },
    getVolunteer: (data) => {
        return http.get('/api/volunteer/info', { params: data })
    },
    saveVolunteer: (data) => {
        return http.post('/api/volunteer/save', { data })
    },
    upLoad: (formData) => {
        return http({
            baseURL: 'http://futureprize.org:8100/sun/upload/file',
            method: 'post',
            header: {
                'Content-Type': 'multipart/form-data;charset=UTF-8',
            },
            data: formData,
        })
    },
    //直播
    prizeLiveList: (data) => {
        return http.get('/api/prizeLive/list', { params: data })
    },
    //大奖周概述
    futureProject: (data) => {
        return http.get('/api/futureProject/get', { params: data })
    },
    //学术指导
    donorProject: (data) => {
        return http.get('/api/donorProject/getList', { params: data })
    },
    //人物详情
    characterInfo: (data) => {
        return http.get('/api/detail/characterInfo', { params: data })
    },
}

export default api